import type { DataStore } from '../data/store';
import type { AccountMonth, Id, YearMonth } from '../data/types';

// Mapping di dominio esplicito. I gruppi non elencati sono attività; il segno del saldo
// non cambia la natura del conto quando attraversa temporaneamente lo zero.
const LIABILITY_GROUP_IDS = new Set<Id>(['288d86e4-dfa4-44f9-8eda-74003aad497b']);
const LIABILITY_GROUP_TYPES = new Set([2, 5, 9]);

export function isLiabilityGroup(store: DataStore, groupId: Id): boolean {
  const type = store.groupById.get(groupId)?.group_type;
  return (
    LIABILITY_GROUP_IDS.has(groupId) ||
    (type !== null && type !== undefined && LIABILITY_GROUP_TYPES.has(type))
  );
}

export function selectedAccountMonths(
  store: DataStore,
  month: YearMonth,
  accountIds?: readonly Id[],
): AccountMonth[] {
  const accounts = accountIds ? new Set(accountIds) : undefined;
  return store.core.account_month.filter(
    (row) => row.month === month && (accounts === undefined || accounts.has(row.account_id)),
  );
}

export function meaningfulChange(current: number, previous: number): number | null {
  if (previous === 0 || (current !== 0 && Math.sign(previous) !== Math.sign(current))) return null;
  return (current - previous) / Math.abs(previous);
}
